import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import {daoGet} from "mrf/Dao";
import T from "mrf/utils/T";
import {useEffect, useState} from "react";

export default function SwaggerDocs() {
    const [swagger, setSwagger] = useState();

    useEffect(() => {
        async function loadSwaggerUI() {
            try {
                const swaggerJson = await daoGet("/api/swagger/v1/swagger.json");
                setSwagger(swaggerJson);

            } catch (e) {
                alert(T('An unexpected error has occurred!'));
            }
        }
        loadSwaggerUI();
    }, []);

    return <SwaggerUI spec={swagger} />
}